import { Realm } from "@models/Realm";

export const DISTRIBUTOR_HOME_URL = "/dist";
export const STANDARD_HOME_URL = "/";

export const getHomeUrl = (realm: Realm): `/${string}` => {
  if (realm === Realm.Distributor) {
    return DISTRIBUTOR_HOME_URL;
  }
  return STANDARD_HOME_URL;
};

export const distUrl = (path: `/${string}`): `/${string}` => {
  return `${DISTRIBUTOR_HOME_URL}${path}`;
};

export const realmPathUrl = (
  realm: Realm,
  path: `/${string}`
): `/${string}` => {
  if (realm === Realm.Distributor) {
    return distUrl(path);
  }
  return path;
};

export const isPathForDistributorRealm = (path: string) => {
  return path.startsWith(DISTRIBUTOR_HOME_URL);
};
